import { GroupStyle } from "../../components/Group/GroupStyle/GroupStyle";
import GroupStyleUpgradePrompt from "../../components/Group/GroupStyle/components/GroupStyleUpgradePrompt";
import NameHeading from "../../components/NameHeading";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectGroupById } from "../../features/groups/groupSlice";

const GroupStyleRoute = (): JSX.Element => {
  const { groupid } = useParams<{ groupid: string }>();
  const group = useAppSelector((state) => selectGroupById(state, groupid ?? ""));
  const hasStyleAccess = group?.subscription?.plan_name === "Tier 3";

  return (
    <div className="w-full h-[80vh] overflow-y-auto px-4 py-6">
      {group && <NameHeading name={group.name} />}
      {hasStyleAccess ? (
        <GroupStyle />
      ) : (
        groupid && <GroupStyleUpgradePrompt groupId={groupid} />
      )}
    </div>
  );
};

export default GroupStyleRoute;
